import type { FC } from "react";
import { EmptyPlaceholderText } from "../EmptyPlaceholderText";
import { ExternalLinkIcon } from "../../../shared/icons";
import type { InputProps } from "../../DynamicInput";
import { DynamicShared } from "../../../dynamicShared";
import { Text } from "./Text";

export const ExternalLink: FC<InputProps<string>> = props => {
  return (
    <Text
      {...props}
      Icon={ExternalLinkIcon}
      renderNonEditingInputContent={value =>
        value ? (
          <DynamicShared.ExternalLink sx={{ mr: 10 }} href={value}>
            {value}
          </DynamicShared.ExternalLink>
        ) : (
          <EmptyPlaceholderText />
        )
      }
    />
  );
};
